export default __webpack_public_path__ + "static/media/projects.471fe875.svg";